import { Box, Menu } from "@chakra-ui/react"
import { filterConstants } from "../../../../../../common/constants/search-constants"
import { FhResponseData } from "../../../../../../common/types/search"
import { isFilterOptionToBeRemoved } from "../../../../../../common/utils/search-utils"
import FilterButton from "./FilterButton/FilterButton"
import FilterOptions from "./FilterOptions/FilterOptions"

type Props = {
  filterData: FhResponseData
  breadcrumbFilters: FhResponseData
  showFiltersNoResultsView: boolean
  rid: string
}

/* This is the desktop filters component */
const Filter = ({ filterData, breadcrumbFilters, showFiltersNoResultsView, rid }: Props) => {
  const { title, filtersection, basetype } = filterData
  const isBasetypeSetOrList = basetype === filterConstants.SET || basetype === filterConstants.LIST

  /* Remove filter if nr is 0 or basetype is set or list and name === value
   Comment from PBI why we have the second check: Fredhopper expects to have translations for all created value IDs per product
   in all locales and at the moment thats not the case, so we hide them for now */
  const filteredFiltersection = filtersection.filter(
    (filterOption: FhResponseData) =>
      !isFilterOptionToBeRemoved(filterOption, isBasetypeSetOrList, showFiltersNoResultsView)
  )

  const isFilterSelected = filteredFiltersection.some((filter: FhResponseData) => filter.selected)

  return (
    <Box>
      <Menu
        gutter={0}
        autoSelect={false}
        closeOnSelect={false}
        flip={false}
        isLazy // Render the menu items onOpen of filter for faster SRP initial load time
      >
        {({ isOpen, onClose }) => (
          <>
            <FilterButton title={title} isOpen={isOpen} isFilterSelected={isFilterSelected} />
            <FilterOptions
              filterData={filterData}
              breadcrumbFilters={breadcrumbFilters}
              showFiltersNoResultsView={showFiltersNoResultsView}
              handleOnClose={onClose}
              rid={rid}
            />
          </>
        )}
      </Menu>
    </Box>
  )
}

export default Filter
